import { collect as Rcollect, record } from 'fp-ts/Record';
/**
 *  @since 0.0.1
 */
export const mapRecord = (d, f) => record.map(d, f);
/**
 *  @since 0.0.1
 */
export const projectField = (t) => (k) => record.map(t, p => p[k]);
/**
 *  @since 0.0.1
 */
export const projectFieldWithEnv = (t, env) => (k) => record.map(t, p => p(env)[k]);
/**
 *  @since 0.0.1
 */
export const merge = (...x) => Object.assign({}, ...x);
/**
 *  @since 0.0.1
 */
export const collect = (d, f) => Rcollect(f)(d);
/**
 *  @since 0.0.1
 */
export const memo = (get) => {
    let cache = undefined;
    return (() => {
        if (cache === undefined) {
            cache = get();
        }
        return cache;
    });
};
/**
 *  @since 0.0.1
 *
 * Returns a function returning the index of the first guard matching a particular Objet
 * Caching the result under the given Symbol inside the Object
 */
export const getGuardId = (guards, sym) => {
    const len = guards.length;
    return (a) => {
        const isObj = typeof a === 'object' && a !== null;
        if (isObj) {
            const r = a[sym];
            if (r !== undefined) {
                return r;
            }
        }
        for (let i = 0; i < len; i++) {
            if (guards[i](a)._tag === 'Right') {
                if (isObj) {
                    a[sym] = i;
                }
                return i;
            }
        }
        return -1;
    };
};
